// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ricarica/riaddebiti?societaId&anno&mese',
    requestBody: null,
    response: '{"success":"true","data":{"periodo":{"stato":"APERTO|CHIUSO","chiusoAt":"string|null","chiusoDa":"string|null"},"righe":[{"dipendente":{"id":"number","nome":"string","cognome":"string","codiceFiscale":"string|null"},"sessioni":"number","energiaWh":"number","importo":"number","tardive":"number"}],"totali":{"sessioni":"number","energiaWh":"number","importo":"number"},"avvisi":{"anomale":"number","inCorso":"number","nonCollegate":"number","precedentiNonChiusi":[{"anno":"number","mese":"number","sessioni":"number"}]}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/riaddebiti/export?societaId&anno&mese',
    requestBody: null,
    response: 'file xlsx (fogli Riepilogo e Dettaglio; "-provvisorio" nel nome se il mese non è chiuso)'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/riaddebiti/chiudi',
    requestBody: '{"societaId":"number","anno":"number","mese":"number"}',
    response: '{"success":"true","data":{"sessioni":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/riaddebiti/riapri',
    requestBody: '{"societaId":"number","anno":"number","mese":"number"}',
    response: '{"success":"true","data":{"sessioni":"number"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
